<template>
    <div class="row">
        <div class="col-12">
            <div class="col-12">
                <h1 class="title-tab-content">مربیان و خودروها</h1>
            </div>
            <div class="content-section default">
                <div class="content-section default" v-if="educatorAndCars.length > 0">
                    <div class="row">
                        <!--<h5 style="padding-right:10px;">نمایش اطلاعات</h5>-->
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" class="center-text">ردیف</th>
                                        <th scope="col" class="center-text">جنسیت</th>
                                        <th scope="col">نام</th>
                                        <th scope="col">نام‌خانوادگی</th>
                                        <th scope="col" class="center-text">شماره موبایل</th>
                                        <th scope="col" class="center-text">سیستم خودرو</th>
                                        <th scope="col" class="center-text">مدل خودرو</th>
                                        <th scope="col" class="center-text">شماره پلاک</th>
                                    </tr>
                                </thead>
                                <tr v-for="(educatorAndCar, index) in educatorAndCars" :key="index">
                                    <th scope="row" class="center-text">{{ index + 1 }}</th>
                                    <td class="center-text">{{ educatorAndCar.Gender }}</td>
                                    <td>{{ educatorAndCar.FirstName }}</td>
                                    <td>{{ educatorAndCar.LastName }}</td>
                                    <td class="center-text">{{ educatorAndCar.MobNo }}</td>
                                    <td class="center-text">{{ educatorAndCar.CarType }}</td>
                                    <td class="center-text">{{ educatorAndCar.CarModel }}</td>
                                    <td class="center-text">{{ educatorAndCar.CarPlaque }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="row" v-else>
                    <!--<h6 style="padding-right:10px;">نمایش اطلاعات</h6>-->
                    <div class="col-12 text-center">
                        <div class="content-section pt-5 pb-5">
                            <div class="icon-empty">
                                <i class="now-ui-icons travel_info"></i>
                            </div>
                            <h1 class="text-empty">اطلاعاتی برای نمایش وجود ندارد!</h1>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>

    </div>
</template>
<script>
    import { httpPromise } from "../../module/httpUtility";

    export default {
        data() {
            return {
                educatorAndCars: [],
                isShowSppiner: false,
            }
        },

        created() {
            this.fromDate = this.currentDate;
            this.toDate = this.currentDate;
            this.readEduDrvSession();
        },
        beforeMount: function () {
            createPageTitle('مربیان و خودروها');
            this.readEducators();
        },

        methods: {
            readEduDrvSession() {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Identities/EducatorAndCars/Read', 'get', {},
                    response => {
                        this.educatorAndCars = response.data.Value;
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },
        },
    }
</script>

<style scoped>
    .center-text{
        text-align:center;
    }
</style>